import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { refreshAdditionalCoveragesAtom } from '../atoms/refreshAdditionalCoveragesAtom';
import { currentPackageGroupAtom } from '../atoms/currentPackageGroupAtom';
import { coveragePackagesSelector } from './coveragePackagesSelector';
import { isSavingPackageAtom } from '../atoms/isSavingPackageAtom';
import { coveragePackagePriceSelector } from './coveragePackagesPriceSelector';

export const additionalCoveragesSelector = selector({
    key: 'additionalCoveragesSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        const currentProduct = get(getOnsaCurrentProductSelector);
        get(refreshAdditionalCoveragesAtom);
        const isSavingPackage = get(isSavingPackageAtom);
        if (!currentProduct || isSavingPackage) return [];
        const { lobCode, fixedId } = currentProduct;

        const packageGroupName = get(currentPackageGroupAtom);
        get(coveragePackagesSelector);
        get(coveragePackagePriceSelector);

        return await OnlineSalesUnauthenticated.getAdditionalCoverages(
            jobNumber,
            lobCode,
            fixedId,
            packageGroupName,
            sessionId,
            !isLoggedOn
        );
    }
});
